import { Component, OnInit, Input } from "@angular/core";
import { LangService } from "src/app/services/lang/lang.service";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { LoginComponent } from "src/app/components/modals/login/login.component";
import { SessionService } from "src/app/services/session.service";
import { CartService } from "src/app/services/api/cart.service";
import { SettingsService } from "src/app/services/site/settings.service";
import { Meta, Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { CmsService } from "src/app/services/api/cms.service";
import { CommonService } from "src/app/services/common.service";
import * as $ from 'jquery';
import { SocketioService } from "src/app/services/socketio.service";
import { MaintenanceService } from "src/app/services/api/maintenance.service";
import { environment } from 'src/environments/environment';


@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
	
	modalRef: BsModalRef;

	@Input() headerClass = "bg-white";
	menuIsActive = "";

	activeItems: any = null;
	env = environment;

	/**
	 * this is the replacement of the activeItems for large screen
	 * instead of json data it is now in html format
	 * this variables are in the cmsService
	 * 
	 * headerMenuBtn:any = '';
	 * headerMenuBtnContent:any = '';
	 */

	// For force login of customer to write review
	@Input() checkUrlForceLogin: boolean = false;

	constructor(
		public modalService: BsModalService,
		public lang: LangService,
		public cartService: CartService,
		public _route: ActivatedRoute,
		public sessionService: SessionService,
		public site: SettingsService,
		private meta: Meta,
		public cmsService: CmsService,
		public title: Title,
		public router: Router,
		public commonService: CommonService,
		public socketioService: SocketioService, /** this is here because we want it to be called in all pages */
		public maintenanceService: MaintenanceService
	) {}

  	ngOnInit() {
		// if (this.router.url === '/') {
		// 	this.title.setTitle('Fast and quality stickers: best sticker printing services!');
		// 	this.meta.updateTag({
		// 		name: 'description', 
		// 		content: 'Get the best sticker printing services in the Philippines! Fast sticker printing services with various types of custom sticker printing choices, free shipping, fast delivery!'
		// 	});
		// }
		this._route.paramMap.subscribe(urlParam => {
			this.maintenanceService.getMaintenanceMessage();
			this.setCanonicalLink();

			this.cmsService.getBlock(58, false, true).then(block => {
				let metas = block['content'];
				let key = this._route['_routerState']['snapshot']['url'];
				
				let metaDefaults = {};
				if(typeof metas["default"] != 'undefined') {
					metaDefaults = metas["default"];
				}
	
				if(typeof metas[key] != 'undefined'){
					let meta = metas[key];
					this.title.setTitle(meta['meta_title']);
					this.meta.updateTag({
						name: 'keywords', 
						content: meta['meta_keyword'] ? meta['meta_keyword'] : metaDefaults['meta_keyword'] ? metaDefaults['meta_keyword'] : 'EntreLabel'
					});
					this.meta.updateTag({
						name: 'description', 
						content: meta['meta_description'] ? meta['meta_description'] : metaDefaults['meta_description'] ? metaDefaults['meta_description'] : 'EntreLabel'
					});
				} else {
					/** the page title is being set on the page */
					this.meta.updateTag({
						name: 'keywords', 
						content: metaDefaults['meta_keyword'] ? metaDefaults['meta_keyword'] : 'EntreLabel'
					});
					this.meta.updateTag({
						name: 'description', 
						content: metaDefaults['meta_description'] ? metaDefaults['meta_description'] : 'EntreLabel'
					});
				}
			});
		});

		this.setDropDownMenuListeners();

		this.site.getConfigPromise("/rest/entrelable/V1/lns-entrelabel/config/site/setting","site_settings").then((config) => {
			let c: any = config;
			if (typeof c.site_settings != "undefined") {
				this.activeItems = c.site_settings.active_items;
			}
		});
		if (this.checkUrlForceLogin) {
			this.openModal();
		}
  	}

	setCanonicalLink(){
		let l = window.location;
		let cl = environment.stroreBaseUrl + l.pathname;

		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			let el = links[i];
			if (typeof el['rel'] != 'undefined') {
				if(el.rel == 'canonical'){
					el.setAttribute('href', cl);
					break;
				}
			}
		}
	}
	
	/**
	 * add click listeners to the buttons since this
	 * is from cms API content
	 */
	async setDropDownMenuListeners(){
		// if(!this.cmsService.headerMenuBtn){
		// 	let content = await this.cmsService.getHndCmsPage('entrelabel-main-header-nav', true, false);
		// 	this.cmsService.headerMenuBtn = content.content;
		// }

		// let a = this;
		// let checker = setInterval(f => {
		// 	let el = $('.header-drop-down-btn');
		// 	if(el.length){
		// 		el.on('click', function(e){
		// 			e.stopPropagation();
		// 			$(document).off('click');
		// 			a.showDropDown(this, e);
		// 		});
		// 		clearInterval(checker);
		// 	}
		// }, 100);

		// if(!this.cmsService.headerMenuBtnContent){
		// 	let _content = await this.cmsService.getHndCmsPage('entrelabel-main-header-nav-drop-down-content', true, false, '.hnd-cms-img');
		// 	this.cmsService.headerMenuBtnContent = _content.content;
		// }
		
		this.commonService.addRouterLink('.cms-link');
	}

	/**
	 * handle the click event
	 * @param evt 
	 */
	isDropDownMenuToggled:boolean = false;
	showDropDown(evt:any){

		let el = $(evt.target)[0];
		let dataTarget = el.getAttribute("data-target");
		if(dataTarget){
			$('.drop-down-menu-items').hide();
			$('.drop-down-menu-items.' + dataTarget).show();

			if(!this.isDropDownMenuToggled){
				$('.main-header-drop-down-links').toggle("fast", f => {
					this.isDropDownMenuToggled = true;
					$(document).on("click", () => {
						$('.main-header-drop-down-links').hide();
						this.isDropDownMenuToggled = false;
						$(document).off('click');
					});
				});
			} else {
				$(document).on("click", () => {
					$('.main-header-drop-down-links').hide();
					this.isDropDownMenuToggled = false;
					$(document).off('click');
				});
			}
		}
		else {
			$('.main-header-drop-down-links').hide();
			$(document).off('click');
			this.isDropDownMenuToggled = false;
			let link = el.getAttribute('href');
			this.router.navigate([link]);
			evt.preventDefault();
		}
	}

  /**
   * we do not use ngx-bootstrap modal for mobile view menu
   * so we need to set either it is active or not
   */
  setMenu() {
    if (this.menuIsActive == "") {
      this.menuIsActive = "active";
    } else {
      this.menuIsActive = "";
    }
  }

  closeMenu() {
    setTimeout(() => {
      this.setMenu();
    }, 500);
  }

  /**
   * open the login modal
   */
  openModal() {
    const config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {},
    };
    let initialState = {};

    this.modalRef = this.modalService.show(LoginComponent, config);
    this.modalRef.setClass("login-modal modal-dialog-centered");
    this.modalRef.content.onClose = (myData) => {
      this.modalRef.hide();
    };
  }

  /**
   * set user as log out
   */
  signOut() {
    this.sessionService.signOut();
  }
}
